import { apiClient } from '../../../api/interceptor';
import { API_ROUTES } from './constants';

export const getPaymentPublishableKey = () => {
  return apiClient({
    method: API_ROUTES.PAYMENT_PUBLISHABLE_KEY.METHOD,
    url: API_ROUTES.PAYMENT_PUBLISHABLE_KEY.URL,
  });
};

export const getPublicPaymentLinkPublishableKey = ({ pt }) => {
  return apiClient({
    method: API_ROUTES.PUBLIC_PAYMENT_LINK_PUBLISHABLE_KEY.METHOD,
    url: API_ROUTES.PUBLIC_PAYMENT_LINK_PUBLISHABLE_KEY.URL,
    params: { pt },
    headers: {
      Authorization: `Bearer ${pt}`,
    },
  });
};

export const stripePayment = ({ id, data, authToken }) => {
  return apiClient({
    method: API_ROUTES.STRIPE_PAYMENT.METHOD,
    url: `payment/${id}/${API_ROUTES.STRIPE_PAYMENT.URL}`,
    data,
    ...(authToken
      ? {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      : {}),
  });
};

export const createStripeIntent = ({ id, data, authToken }) => {
  return apiClient({
    method: API_ROUTES.CREATE_STRIPE_INTENT.METHOD,
    url: `payment/${id}/${API_ROUTES.CREATE_STRIPE_INTENT.URL}`,
    data,
    ...(authToken
      ? {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      : {}),
  });
};

export const getCustomerDashboardDetails = ({ id, data }) => {
  return apiClient({
    method: API_ROUTES.CUSTOMER_DASHBOARD.METHOD,
    url: `customer/${id}/${API_ROUTES.CUSTOMER_DASHBOARD.URL}`,
    data,
  });
};
export const getProviderDashboardDetails = (data) => {
  return apiClient({
    method: API_ROUTES.PROVIDER_DASHBOARD.METHOD,
    url: `${API_ROUTES.PROVIDER_DASHBOARD.URL}`,
    data,
  });
};

export const getProviderDashboardCdrStats = (data) => {
  return apiClient({
    method: API_ROUTES.PROVIDER_DASHBOARD_CDR_STATS.METHOD,
    url: `${API_ROUTES.PROVIDER_DASHBOARD_CDR_STATS.URL}`,
    data,
  });
};

export const getDashboardStats = (data) => {
  return apiClient({
    method: API_ROUTES.DASHBOARD_STATS.METHOD,
    url: `${API_ROUTES.DASHBOARD_STATS.URL}`,
    data,
  });
};

export const exportDashboardStats = (data) => {
  return apiClient({
    method: API_ROUTES.DASHBOARD_EXPORT.METHOD,
    url: `${API_ROUTES.DASHBOARD_EXPORT.URL}`,
    data,
  });
};
